<div id="content-section">
  <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
    <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
        </small>
      </div>
      <a routerLink="/contacts/new" class="btn btn-primary btn-sm" style="width: 100%">
        <i class="fas fa-plus-circle"></i>
        &nbsp;New Contact
      </a>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="text-center pagination-small-margin pagination-center">
        <pagination [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="searchParams.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
      <div class="text-center pt-1">
        <app-pagination-count 
          [count]="count"
          singularName="Contact"
          pluralName="Contacts"
        ></app-pagination-count>
      </div>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="sticky-top bg-white">
        <h5 class="pt-2">
          <div class="pull-right float-right">
            <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
          </div>
          <span>
            Search&nbsp;&nbsp;
            <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search() : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
          </span>
        </h5>
        <hr class="my-1" />
      </div>
      <div class="row">
        <div class="col-md-12" id="search-form" style="border-bottom: 1px solid #ccc">
          <div class="form-group mt-3">
            <label>Flexible Search</label>
            <input type="text" class="form-control" name="flex_search" (keyup.enter)="search()" [(ngModel)]="searchParams.text" />
          </div>
          <div class="form-group">
            <label>Tagged With</label>
            <input type="text" class="form-control" name="tag" [(ngModel)]="searchParams.tag" (keyup.enter)="search()" placeholder="family law, criminal, referral source" />
            <small class="form-text text-muted">Separate tag phrases with commas; all listed tags are required.</small>
          </div>
          <div class="form-group">
            <label>Zip or Postal Code</label>
            <input type="text" class="form-control" name="postal_code" [(ngModel)]="searchParams.postal_code" (keyup.enter)="search()" />
          </div>
          <div class="form-group">
            <label>County</label>
            <input type="text" class="form-control" name="county" [(ngModel)]="searchParams.county" (keyup.enter)="search()" />
          </div>
          <div class="form-group">
            <label>City</label>
            <input type="text" class="form-control" name="city" [(ngModel)]="searchParams.city" (keyup.enter)="search()" />
          </div>
          <!-- Not in use for current solr search
					<div class='form-group'>
						<label>Matter User</label>
						<select class='form-control' name='user_id' [(ngModel)]='searchParams.user_id'>
							<option *ngFor='let matterUser of this.searchOptions.matter_users' [value]='matterUser.value'>
								{{matterUser.label}}
							</option>
						</select>
					</div>
					-->
          <div class="form-group">
            <label>Matter</label>
            <app-matter-search (clearMatter)="searchParams.matter_id = undefined" (matter_id)="searchParams.matter_id = $event"></app-matter-search>
            <small class="form-text text-muted">Limit to involvements of this matter</small>
          </div>
          <hr />
          <div class="form-group">
            <label>Filter by one of the below</label><br />
            <div class="custom-control custom-radio custom-control-inline" (click)="searchOptions.radio_1 = 'role_types'">
              <input type="radio" name="radio_1" [checked]="searchOptions.radio_1 == 'role_types' || !searchOptions.radio_1" class="custom-control-input" />
              <label class="custom-control-label">Role Types</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline" (click)="searchOptions.radio_1 = 'matter_user_types'; searchParams.role_type_ids = []; searchParams.role_types = []">
              <input type="radio" [checked]="searchOptions.radio_1 == 'matter_user_types'" name="radio_1" class="custom-control-input" />
              <label class="custom-control-label">Matter User Types</label>
            </div>
          </div>
          <div class="form-group" *ngIf="searchOptions.radio_1 == 'role_types' || !searchOptions.radio_1">
            <label>Involvement Role</label>
            <input type="text" class="form-control" [(ngModel)]="selectedRoleType" [typeahead]="searchOptions.role_types" (typeaheadOnSelect)="addRoleTypeToSearch($event.item)" typeaheadOptionField="name" name="role_search" placeholder="Search and Add" *ngIf="searchOptions.role_types.length > 0" />
            <div class="card mt-1">
              <div class="card-body p-2" style="height: 70px; overflow-y: scroll">
                <div *ngFor="let roleType of this.searchParams.role_types; first as isFirst" [ngClass]="{ 'border-top': !isFirst }">
                  <div class="float-right py-1">
                    <a class="text-danger" href="#" (click)="$event.stopPropagation(); $event.preventDefault(); removeRoleTypeFromSearch(roleType)">
                      <i class="fas fa-times"></i>
                    </a>
                  </div>
                  {{ roleType.label }}
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="searchOptions.radio_1 == 'matter_user_types'">
            <label>Matter User Type</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="selectedMatterUserType"
              [typeahead]="searchOptions.matter_user_types"
              (typeaheadOnSelect)="addMatterUserTypeToSearch($event.item)"
              typeaheadOptionField="name"
              name="matter_user_type_search"
              placeholder="Search and Add"
              *ngIf="searchOptions.matter_user_types.length > 0"
            />
            <div class="card mt-1">
              <div class="card-body p-2" style="height: 70px; overflow-y: scroll">
                <div *ngFor="let matterUserType of this.searchParams.matter_user_types; first as isFirst" [ngClass]="{ 'border-top': !isFirst }">
                  <div class="float-right py-1">
                    <a class="text-danger" href="#" (click)="$event.stopPropagation(); $event.preventDefault(); removeMatterUserTypeFromSearch(matterUserType)">
                      <i class="fas fa-times"></i>
                    </a>
                  </div>
                  {{ matterUserType.label }}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <!-- Not being used in solr at the moment
					<div class='form-group'>
						<label>Matter Type</label>
						<input type='text' class='form-control' [(ngModel)]='selectedMatterType' [typeahead]="searchOptions.matter_types" (typeaheadOnSelect)='addMatterTypeToSearch($event.item)' typeaheadOptionField="name" name='matter_type_search' placeholder='Search and Add' *ngIf='searchOptions.matter_types.length > 0' />
						<div class='card mt-1'>
							<div class='card-body p-2' style='height: 70px;overflow-y: scroll;'>
								<div *ngFor='let matterType of this.searchParams.matter_types; first as isFirst' [ngClass]='{ "border-top": !isFirst }'>
									<div class='float-right py-1'>
										<a class='text-danger' href='#' (click)='$event.stopPropagation();$event.preventDefault();removeMatterTypeFromSearch(matterType)'>
											<i class='fa fa-times'></i>
										</a>
									</div>
									{{matterType.label}}
								</div>
							</div>
						</div>
					</div>
					-->
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="searchParams.is_on_mailing_list = !searchParams.is_on_mailing_list; searchParams.is_on_mailing_list ? searchParams.is_on_mailing_list : (searchParams.is_on_mailing_list = undefined)">
              <input type="checkbox" class="custom-control-input" name="is_on_mailing_list" [checked]="searchParams.is_on_mailing_list" />
              <label class="custom-control-label">On Mailing List</label>
            </div>
          </div>
          <div class="form-group">
            <button (click)="searchParams.page = 1; search()" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
              Search
              <span *ngIf="searching">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <h2 class="pt-4 text-center">Contacts</h2>
        <hr class="mt-1 mb-2" />
        <div class="card mb-2" *ngIf="count > 0">
          <div class="card-header">
            <a href="#" (click)="showBulkEdit = !showBulkEdit; $event.preventDefault(); $event.stopPropagation()"> <i class="fas" [ngClass]="{ 'fa-plus-circle': !showBulkEdit, 'fa-minus-circle': showBulkEdit }"></i>Bulk Edit </a>
          </div>
          <div class="card-body" *ngIf="showBulkEdit">
            <p class="card-text text-muted">Select contacts for edit below the form</p>
            <div class="form-group">
              <label>Notes&nbsp;&nbsp;&nbsp;&nbsp;</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_notes = '1'">
                <input type="radio" name="append_notes" class="custom-control-input" value="1" [checked]="bulkEditParams.append_notes == '1'" />
                <label class="custom-control-label">Append</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_notes = '0'">
                <input type="radio" name="append_notes" class="custom-control-input" value="0" [checked]="bulkEditParams.append_notes == '0'" />
                <label class="custom-control-label">Replace</label>
              </div>
              <textarea class="form-control" name="notes" placeholder="Notes" [(ngModel)]="bulkEditParams.notes"></textarea>
            </div>
            <div class="form-group">
              <label>Tags&nbsp;&nbsp;&nbsp;&nbsp;</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_tags = '1'">
                <input type="radio" name="append_tags" class="custom-control-input" value="1" [checked]="bulkEditParams.append_tags == '1'" />
                <label class="custom-control-label">Append</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.append_tags = '0'">
                <input type="radio" name="append_tags" class="custom-control-input" value="0" [checked]="bulkEditParams.append_tags == '0'" />
                <label class="custom-control-label">Replace</label>
              </div>
              <input class="form-control" name="tag_list" placeholder="Tags" [(ngModel)]="bulkEditParams.tag_list" />
            </div>
            <div class="form-group">
              <label>URL</label>
              <input class="form-control" name="url" placeholder="URL" [(ngModel)]="bulkEditParams.url" />
              <div class="custom-control custom-checkbox" (click)="bulkEditParams.remove_url = !bulkEditParams.remove_url">
                <input type="checkbox" class="custom-control-input" name="remove_url" [checked]="bulkEditParams.remove_url" />
                <label class="custom-control-label">Remove URL</label>
              </div>
            </div>
            <div class="form-group">
              <label>Owner</label>
              <select class="form-control" name="owned_by" [(ngModel)]="bulkEditParams.owned_by">
                <option *ngFor="let user of bulkEditOptions.users" [value]="user.value">{{ user.label }}</option>
              </select>
              <div class="custom-control custom-checkbox" (click)="bulkEditParams.remove_owner = !bulkEditParams.remove_owner">
                <input type="checkbox" class="custom-control-input" name="remove_owner" [checked]="bulkEditParams.remove_owner" />
                <label class="custom-control-label">Remove Owner</label>
              </div>
            </div>
            <div class="form-group">
              <label>Newsletter Mailing List&nbsp;&nbsp;&nbsp;</label>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.add_to_mailing_list = '1'">
                <input type="radio" name="add_to_mailing_list" class="custom-control-input" value="1" [checked]="bulkEditParams.add_to_mailing_list == '1'" />
                <label class="custom-control-label">Append</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.add_to_mailing_list = '0'">
                <input type="radio" name="add_to_mailing_list" class="custom-control-input" value="0" [checked]="bulkEditParams.add_to_mailing_list == '0'" />
                <label class="custom-control-label">Replace</label>
              </div>
              <select class="form-control" name="newsletter_mailing_list_id" [(ngModel)]="bulkEditParams.newsletter_mailing_list_id">
                <option *ngFor="let newsletter_mailing_list of bulkEditOptions.newsletter_mailing_lists" [value]="newsletter_mailing_list.value">{{ newsletter_mailing_list.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox custom-control-inline" (click)="bulkEditParams.is_private = !bulkEditParams.is_private">
                <input [disabled]="bulkEditParams.privacy" type="checkbox" class="custom-control-input" name="is_private" [checked]="bulkEditParams.is_private" />
                <label class="custom-control-label">Is Private</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline" (click)="bulkEditParams.privacy = !bulkEditParams.privacy">
                <input type="checkbox" class="custom-control-input" name="privacy" [checked]="bulkEditParams.privacy" />
                <label class="custom-control-label">Do not modify contact privacy</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox custom-control-inline" (click)="bulkEditParams.is_on_mailing_list = !bulkEditParams.is_on_mailing_list">
                <input [disabled]="bulkEditParams.mailing_list_check" type="checkbox" class="custom-control-input" name="is_on_mailing_list" [checked]="bulkEditParams.is_on_mailing_list" />
                <label class="custom-control-label">Is On Mailing List</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline" (click)="bulkEditParams.mailing_list_check = !bulkEditParams.mailing_list_check">
                <input type="checkbox" class="custom-control-input" name="mailing_list_check" [checked]="bulkEditParams.mailing_list_check" />
                <label class="custom-control-label">Do not modify default mailing list option</label>
              </div>
            </div>
            <div class="form-group">
              <button [disabled]="submittingBulkEdit" type="button" class="btn btn-primary" (click)="bulkEdit()">
                Save
                <span *ngIf="submittingBulkEdit">
                  &nbsp;
                  <i class="fas fa-spinner fa-fw fa-pulse"></i>
                </span>
              </button>
              &nbsp;
              <button [disabled]="submittingBulkEdit" type="button" class="btn btn-outline-secondary" (click)="showBulkEdit = false">Cancel</button>
            </div>
          </div>
        </div>
        <div class="table-responsive-md">
          <table class="table table-striped" *ngIf="count > 0">
            <thead>
              <tr *ngIf="showBulkEdit">
                <td>
                  <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.contacts_bulk_edit_selection = 'select_all'">
                    <input type="radio" name="contacts_bulk_edit_selection" class="custom-control-input" [checked]="bulkEditParams.contacts_bulk_edit_selection == 'select_all'" />
                    <label class="custom-control-label">Select All results</label>
                  </div>
                </td>
                <td>
                  <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.contacts_bulk_edit_selection = 'select_current'">
                    <input type="radio" name="contacts_bulk_edit_selection" class="custom-control-input" [checked]="bulkEditParams.contacts_bulk_edit_selection == 'select_current'" />
                    <label class="custom-control-label">Select All in current page</label>
                  </div>
                </td>
                <td>
                  <div class="custom-control custom-radio custom-control-inline" (click)="bulkEditParams.contacts_bulk_edit_selection = 'user_select'">
                    <input type="radio" name="contacts_bulk_edit_selection" class="custom-control-input" [checked]="bulkEditParams.contacts_bulk_edit_selection == 'user_select'" />
                    <label class="custom-control-label">My Selection (available for contacts in current page only)</label>
                  </div>
                </td>
                <td>
                  <button type="button" (click)="deselectAll()" class="btn btn-outline-secondary btn-sm"><i class="fas fa-ban"></i>&nbsp;Deselect all</button>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let contact of contacts">
                <td>
                  <div *ngIf="bulkEditParams.contacts_bulk_edit_selection == 'user_select' && showBulkEdit">
                    <div class="custom-control custom-checkbox custom-control-inline" (click)="contact.selected = !contact.selected">
                      <input type="checkbox" class="custom-control-input" [checked]="contact.selected" />
                      <label class="custom-control-label"></label>
                    </div>
                  </div>
                </td>
                <td>
                  <a [routerLink]="'/contacts/' + contact.id">
                    {{ contact.name }}
                  </a>
                </td>
                <td>{{ contact.primary_email }}</td>
                <td>{{ contact.primary_phone }}</td>
                <td>
                  <span *ngIf="contact.matter_ids_size < 1"> No Matters </span>
                  <span *ngIf="contact.matter_ids_size > 0">
                    <a [href]="contact.matters_url" [title]="'Go to the ' + contact.matter_ids_size + ' matters for ' + contact.name" target="_blank">
                      <i class="fas fa-link"></i>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
